import { setSendMessageSuccess } from './actions';
import { TThunkAction } from '../../types/redux/thunk';
import { createWsMessage } from '../../utils/message';

export const addTextMessageToChat =
  (text: string, chatId: string, messageId?: string, userId?: number): TThunkAction<void> =>
  (dispatch, getState, context) => {
    const {
      user: { userId: id },
    } = getState();

    const message = createWsMessage({
      text,
      chatId,
      uid: messageId,
      userId: userId !== undefined ? userId : id,
    });

    dispatch(
      setSendMessageSuccess({
        message,
        messageId: messageId || /* istanbul ignore next */ message.messageId,
        messagesMap: context.custom.messagesMap,
      }),
    );
  };
